import React from "react";
import { Badge, HStack } from "@commonsku/design-system";
import { TASKS_DISPLAY_LIMIT } from "../../../redux/myTasks";

export interface TaskTabLabelProps {
  label: string;
  newlyPostedCount: number;
}

// A count at the display limit may be an undercount (see TASKS_DISPLAY_LIMIT) - show "N+".
const formatCount = (count: number): string =>
  count >= TASKS_DISPLAY_LIMIT ? `${TASKS_DISPLAY_LIMIT}+` : String(count);

const TaskTabLabel = ({ label, newlyPostedCount }: TaskTabLabelProps) => (
  <HStack as="span" gap="1.5">
    <span>{label}</span>
    {newlyPostedCount > 0 && (
      <Badge
        colorPalette="brand"
        variant="solid"
        size="xs"
        rounded="full"
        minW="16px"
        h="16px"
        px="4px"
        justifyContent="center"
        alignItems="center"
      >
        {formatCount(newlyPostedCount)}
      </Badge>
    )}
  </HStack>
);

export default TaskTabLabel;
